// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"A8-z"};